import { useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ValidationResult } from "@idw-types/common/validation-result";
import {
    getValidationTypeErrorMessage,
    getValidationTypeInProgressLabel,
    getValidationTypeSubheading,
    getValidationTypeSuccessMessage
} from "@utils/validation-type-util";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";
import classNames from "classnames";
import styles from "./quality-check.less";

type QualityCheckProps = {
    validationResult: ValidationResult;
};

export const QualityCheck = (props: QualityCheckProps) => {
    const { validationResult } = props;
    const content = useSelector(getLanguageContent);

    const qualityCheckIcon = useMemo(() => {
        if (validationResult.isValid) {
            return <FontAwesomeIcon icon={faCheckCircle} className={styles.successIcon} />;
        } else if (!validationResult.isValid && !validationResult.isRequired) {
            return <FontAwesomeIcon icon={faExclamationTriangle} className={styles.warningIcon} />;
        } else if (!validationResult.isValid && validationResult.isRequired) {
            return <FontAwesomeIcon icon={faTimesCircle} className={styles.errorIcon} />;
        } else {
            return null;
        }
    }, [validationResult.isValid, validationResult.isRequired]);

    const renderTooltip = (props: any) => {
        const tooltipMessage = validationResult.isValid
            ? getValidationTypeSuccessMessage(validationResult.type, content)
            : getValidationTypeErrorMessage(validationResult.type, content);
        return (
            <Tooltip {...props} >{tooltipMessage}</Tooltip>
        )
    };
    
    if (!validationResult || validationResult.isDisabled) {
        return null;
    }

    return (
        <div className={styles.qualityCheck}>
            {validationResult.inProgress && (
                <div className={styles.qualityCheckInProgress}>
                    <FontAwesomeIcon icon={faSpinner} className={classNames(styles.spinnerIcon, "fa-spin")} />
                    {getValidationTypeInProgressLabel(validationResult.type, content)}
                </div>
            )}
            {!validationResult.inProgress && (
                <div className={styles.qualityCheckResultContainer}>
                    {qualityCheckIcon}
                    <div className={styles.qualityCheckResult}>
                        <h3>{getValidationTypeSubheading(validationResult.type, content)}</h3>
                        <OverlayTrigger overlay={renderTooltip}>
                            <div className={styles.infoIconContainer}><FontAwesomeIcon className={styles.infoIcon} icon={faQuestionCircle} /></div>
                        </OverlayTrigger>
                    </div>
                </div>
            )}
        </div>
    )
};